import Axios from "axios";
var RechargeManageService = (function () {
    function RechargeManageService() {
    }
    RechargeManageService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/shop_finance/list", { params: params });
    };
    RechargeManageService.prototype.create = function (params) {
        return Axios.get("supplierclientapi/shop_finance/create", { params: params });
    };
    RechargeManageService.prototype.update = function (params) {
        return Axios.post("supplierclientapi/shop_finance/update", params);
    };
    RechargeManageService.prototype.audit = function (params) {
        return Axios.post("supplierclientapi/shop_finance/audit", params);
    };
    RechargeManageService.prototype.cancel = function (params) {
        return Axios.post("supplierclientapi/shop_finance/cancel", params);
    };
    RechargeManageService.createInstance = function () {
        RechargeManageService.getInstance();
    };
    RechargeManageService.getInstance = function () {
        this._instance = new this();
        return this._instance;
    };
    return RechargeManageService;
}());
export default RechargeManageService;
